export const GHOST_ANIM_MS = 1800;

export function playGhostDrag(): void {
  const anchor =
    document.querySelector<HTMLElement>('.kanban-task-card') ??
    document.querySelector<HTMLElement>('.kanban-list__tasks') ??
    document.querySelector<HTMLElement>('.kanban-list');

  const startX = anchor ? anchor.getBoundingClientRect().left : 120;
  const startY = anchor ? anchor.getBoundingClientRect().top + 8 : 200;

  const mock = document.createElement('div');

  // Mirrors the real .kanban-task-card layout
  mock.innerHTML = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
      <div style="display:flex;gap:4px;align-items:center;">
        <span style="
          border-radius:50vh;
          background:linear-gradient(135deg,#853ce2 0%,#e01d5a 100%);
          color:#fff;padding:2px 8px;font-size:10px;font-weight:600;
          display:inline-flex;align-items:center;gap:3px;line-height:1.5;
        ">✦ Smart Schedule</span>
        <span style="
          border-radius:50vh;border:1px solid #b5b5bc;color:#b5b5bc;
          padding:2px 6px;font-size:10px;line-height:1.5;
        ">30m</span>
      </div>
      <div style="display:flex;align-items:center;gap:3px;max-width:70px;">
        <div style="width:10px;height:10px;border-radius:50%;background:#680ddb;opacity:0.55;flex-shrink:0;"></div>
        <span style="font-size:10px;color:#7c7c7c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">Personal</span>
      </div>
    </div>
    <div style="display:flex;gap:8px;align-items:flex-start;">
      <div style="width:18px;height:18px;border-radius:50%;border:1.5px solid #b5b5bc;flex-shrink:0;margin-top:2px;"></div>
      <div style="font-size:13px;color:#131314;font-weight:500;line-height:1.4;">Deep work session</div>
    </div>
  `;

  Object.assign(mock.style, {
    position: 'fixed',
    left: `${startX}px`,
    top: `${startY}px`,
    width: '280px',
    borderRadius: '16px',
    padding: '16px',
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.08)',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    pointerEvents: 'none',
    zIndex: '9999',
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto',sans-serif",
    boxSizing: 'border-box',
    opacity: '0.9',
    animation: `ghost-drag ${GHOST_ANIM_MS}ms ease-in-out forwards`,
  });

  document.body.appendChild(mock);

  const removeMock = () => {
    if (document.body.contains(mock)) document.body.removeChild(mock);
  };
  mock.addEventListener('animationend', removeMock);
  // Safety net: remove even if animationend never fires (e.g. prefers-reduced-motion)
  setTimeout(removeMock, GHOST_ANIM_MS + 200);
}
